<header class="home-v2__header" role="banner">
  <div class="home-v2__header-bar">
    <div class="home-v2__header-inner">
      <a
        class="home-v2__header-logo"
        routerLink="/home"
        aria-label="Ir al inicio de neocrédito"
      >
        <img
          src="assets/img/Home/svg/logo-neocredito-header.svg"
          alt="neocrédito"
          class="home-v2__header-logo-img"
          width="172"
          height="28"
        />
      </a>

      <nav class="home-v2__header-nav d-none d-lg-flex" aria-label="Navegación principal">
        @for (item of navItems; track item.anchorId) {
          <button
            type="button"
            class="home-v2__header-nav-link"
            [id]="item.elementId"
            (click)="scrollToSection(item, $event)"
          >
            {{ item.label }}
          </button>
        }
      </nav>

      <a
        routerLink="/login"
        class="home-v2__header-btn home-v2__header-btn--login"
        id="btn-home-iniciar-sesion"
        (click)="trackIniciarSesion()"
      >
        {{ content.iniciarSesion }}
      </a>
    </div>
  </div>

  <div class="home-v2__header-accent" aria-hidden="true">
    <span class="home-v2__header-accent-segment home-v2__header-accent-segment--1"></span>
    <span class="home-v2__header-accent-segment home-v2__header-accent-segment--2"></span>
    <span class="home-v2__header-accent-segment home-v2__header-accent-segment--3"></span>
  </div>
</header>
